<template>
  <div class="">
    <div v-for="reservationTimeItem in reservationTimes">
      <reservation-item :reservation="reservation" :reservation-item="reservationTimeItem"/>
    </div>

  </div>
</template>
<script>
import ReservationItem from "../generalComponent/ReservationItem.vue";

export default {
  name: "ShowTimes",
  components: {ReservationItem},
  props: {
    reservation: {},
  },
  computed: {
    reservationTimes() {
      return this.reservation.reservationTimes
    },
  }
}
</script>
<style scoped>

</style>